import { IconButton, Stack, styled, Typography } from '@mui/material';
import { InputText } from 'app/components/elements/InputText';
import { useInjection } from './hook';
import React from 'react';
import { ButtonCustom } from 'app/components/elements/ButtonCustom';
import { HeaderClient } from '../../elements/HeaderClient';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { AddFloorPlan } from 'app/components/elements/AddFloorPlan';

import { Controller } from 'react-hook-form';
import { AddIcon } from 'assets';
export const UploadFloorPlan = () => {
  const {
    backToClient,
    uploadfloorplan,
    handleSubmit,
    onCreateLocation,
    errors,
    fieldNames,
    append,
    remove,
    control,
    paths,
    title,
    state
  } = useInjection();
  const isUpdateMode = state?.mode === 'upload';
  return (
    <WrapperCreatePage>
      <HeaderClient
        searchholder="Search"
        paths={paths}
        onClickButton={backToClient}
        textButton={'Cancel'}
        title={title.textButton}
      />
      <Stack alignItems={'center'} justifyContent={'space-between'} flexDirection={'row'}>
        <Stack alignItems={'flex-start'} gap={2} width={'100%'}>
          {isUpdateMode ? (
            <Stack gap={'10px'} width={'100%'} maxWidth={'532px'}>
              <Stack flexDirection={'row'} gap={1} alignItems={'center'}>
                <Typography fontSize={'16px'} fontWeight={700} color={'#226AAA'}>
                  Add New
                </Typography>
                <IconButton
                  onClick={() => append({ value: '', floorPlan: null })}
                  sx={{ width: '40px', height: '40px' }}>
                  <AddIcon color={'#000'} />
                </IconButton>
              </Stack>
              {fieldNames.map((field, index) => {
                return (
                  <Stack key={field.id} direction="column" spacing={2} alignItems="center" mb={2}>
                    <Stack direction="row" spacing={2} alignItems="center" width="100%">
                      <Controller
                        name={`names.${index}.value`}
                        control={control}
                        render={({ field }) => {
                          return (
                            <InputText
                              inputError={errors.names?.[index]?.value?.message}
                              title={'New location'}
                              placeholder={'Name'}
                              inputProps={{
                                ...field
                              }}
                            />
                          );
                        }}
                      />
                      <IconButton onClick={() => remove(index)}>
                        <RemoveCircleOutlineIcon color={'error'} />
                      </IconButton>
                    </Stack>
                    {process.env.REACT_APP_FLOORPLAN_VISIBLE === 'true' && (
                      <Controller
                        name={`names.${index}.floorPlan`}
                        control={control}
                        render={({ field }) => (
                          <AddFloorPlan
                            label="Floor plan"
                            value={field.value ?? null}
                            errorText={errors.names?.[index]?.floorPlan?.message}
                            onChange={async (selectedFile) => {
                              if (!selectedFile) {
                                field.onChange(null);
                                return;
                              }
                              try {
                                const processedFile = await uploadfloorplan(selectedFile);
                                field.onChange(processedFile ?? null);
                              } catch (error) {
                                console.error('Floor plan processing failed:', error);
                                field.onChange(null);
                              }
                            }}
                            onRemove={() => {
                              field.onChange(null);
                            }}
                          />
                        )}
                      />
                    )}
                  </Stack>
                );
              })}
            </Stack>
          ) : (
            <Stack direction="column" spacing={3} width="100%" maxWidth="800px">
              <Stack width="100%" maxWidth="532px" spacing={3}>
                <Controller
                  name="names.0.value"
                  control={control}
                  render={({ field }) => (
                    <InputText
                      title="Location Name"
                      placeholder="Name"
                      inputError={errors.names?.[0]?.value?.message}
                      inputProps={{ ...field, value: field.value ?? '' }}
                    />
                  )}
                />
                <Controller
                  name="names.0.floorPlan"
                  control={control}
                  render={({ field }) => (
                    <AddFloorPlan
                      label="Floor Plan"
                      value={field.value ?? ''}
                      errorText={errors.names?.[0]?.floorPlan?.message}
                      onChange={async (selectedFile) => {
                        if (!selectedFile) {
                          field.onChange(null);
                          return;
                        }

                        try {
                          const processedFile = await uploadfloorplan(selectedFile);
                          field.onChange(processedFile ?? null);
                        } catch (error) {
                          console.error('Floor plan processing failed:', error);
                          field.onChange(null);
                        }
                      }}
                      onRemove={() => field.onChange(null)}
                    />
                  )}
                />
              </Stack>
            </Stack>
          )}
          <Stack>
            <ButtonCustom
              onClick={handleSubmit(onCreateLocation)}
              label={'Add New'}
              style={{ width: '370px' }}
            />
          </Stack>
        </Stack>
      </Stack>
    </WrapperCreatePage>
  );
};
const WrapperCreatePage = styled(Stack)(() => ({
  padding: '40px 30px 50px 40px',
  width: '100%'
}));
